export const personalInfoConfig = () => {
  return {
    name: {
      show: true,
      required: false,
    },
    ssn: {
      show: true,
      required: false,
    },
    dateOfBirth: {
      show: true,
      required: false,
    },
  };
};
